module.exports = __webpack_public_path__ + "static/media/mask1.53064336.JPG";